module.exports = __webpack_public_path__ + "static/media/Up.6ded7213.svg";